var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    xmlns: "http://www.w3.org/2000/svg",
    height: 99,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    "data-testid": "arrow",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-testid": "svg-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.775 46.62c4.32 0 7.83 3.465 7.83 7.74s-3.51 7.74-7.83 7.74-7.83-3.465-7.83-7.74 3.51-7.74 7.83-7.74Zm0-9.405c9.54 0 17.28 7.65 17.28 17.1 0 9.45-7.74 17.1-17.28 17.1-9.54 0-17.28-7.65-17.28-17.1 0-9.405 7.74-17.1 17.28-17.1Zm0-9.36c14.76 0 26.73 11.835 26.73 26.46s-11.97 26.46-26.73 26.46-26.73-11.835-26.73-26.46c0-14.58 11.97-26.46 26.73-26.46Z",
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeMiterlimit: 2.6131,
      fill: "none"
    },
    className: "fills"
  }), /*#__PURE__*/React.createElement("g", {
    className: "strokes",
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeMiterlimit: 2.6131,
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.775 46.62c4.32 0 7.83 3.465 7.83 7.74s-3.51 7.74-7.83 7.74-7.83-3.465-7.83-7.74 3.51-7.74 7.83-7.74Zm0-9.405c9.54 0 17.28 7.65 17.28 17.1 0 9.45-7.74 17.1-17.28 17.1-9.54 0-17.28-7.65-17.28-17.1 0-9.405 7.74-17.1 17.28-17.1Zm0-9.36c14.76 0 26.73 11.835 26.73 26.46s-11.97 26.46-26.73 26.46-26.73-11.835-26.73-26.46c0-14.58 11.97-26.46 26.73-26.46Z",
    style: {
      fill: "none",
      strokeWidth: 4.03,
      stroke: "rgb(255, 255, 255)",
      strokeOpacity: 1
    },
    className: "stroke-shape"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-testid": "svg-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m71.235 19.62.495 8.01 8.1.495L67.68 40.14l-8.055-.495-.495-8.01L71.235 19.62Z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeMiterlimit: 2.6131,
      fill: "rgb(255, 255, 255)"
    },
    className: "fills"
  }), /*#__PURE__*/React.createElement("g", {
    className: "strokes",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeMiterlimit: 2.6131
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m71.235 19.62.495 8.01 8.1.495L67.68 40.14l-8.055-.495-.495-8.01L71.235 19.62Z",
    style: {
      fill: "none",
      strokeWidth: 4.03,
      stroke: "rgb(255, 255, 255)",
      strokeOpacity: 1
    },
    className: "stroke-shape"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-testid": "svg-g",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-testid": "svg-rect"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 41.715,
    y: 46.1,
    transform: "rotate(-44.733 52.155 47)",
    width: 20.88,
    height: 1.8,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeMiterlimit: 10,
      fill: "rgb(255, 255, 255)"
    },
    className: "fills"
  }), /*#__PURE__*/React.createElement("g", {
    className: "strokes",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 41.715,
    y: 46.1,
    transform: "rotate(-44.733 52.155 47)",
    width: 20.88,
    height: 1.8,
    style: {
      fill: "none",
      strokeWidth: 1,
      stroke: "rgb(255, 255, 255)",
      strokeOpacity: 1
    },
    className: "stroke-shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.fb23ebd6b97625ffe6aa32e00bde5a02.svg";
export { ForwardRef as ReactComponent };